import { render, staticRenderFns } from "./TopicFormationDashboardLayout.vue?vue&type=template&id=d50bb78e&scoped=true&"
import script from "./TopicFormationDashboardLayout.vue?vue&type=script&lang=js&"
export * from "./TopicFormationDashboardLayout.vue?vue&type=script&lang=js&"
import style0 from "./TopicFormationDashboardLayout.vue?vue&type=style&index=0&id=d50bb78e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d50bb78e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VChip,VCol,VIcon,VRow})
